import React, { useState, useRef } from 'react';
import { Link, Grid, Typography, Container, Box } from '@mui/material';
import Page from '../Page';
import Logo from '../shared/Logo';
import AuthEmbed from '../auth/AuthEmbed';
import config from '../../config';

const SignupPage = () => {
  const authPromptRef = useRef(null);
  const [showAuthPrompt, setShowAuthPrompt] = useState(true);

  return (
    <Page
      title={`Login : ${config.appDisplayName}`}
      noindex={false}
      style={{ paddingTop: 0 }}
    >
      <Grid
        sx={{
          backgroundColor: 'background.dark',
          width: '100%',
          minHeight: '100vh',
        }}
        container
      >
        <Grid
          item
          xs={12}
          md={6}
          style={{
            backgroundColor: 'background.paper',
          }}
        >
          <Container sx={{ pb: 10, pt: 10 }} maxWidth="md">
            <Box mb={2} display="flex" justifyContent="center">
              <Link href={config.appLandingPageHost}>
                <Logo />
              </Link>
            </Box>
            <Box mb={2} display="flex" justifyContent="center">
              <Typography variant="h3">Let's get started</Typography>
            </Box>
            <Box mb={2} display="flex" justifyContent="center">
              <Typography variant="subtitle1">
                We're excited to help you start building your fitness app with
                {config.appDisplayName}.
              </Typography>
            </Box>
            <Box mb={2} display="flex" justifyContent="center">
              <Typography variant="subtitle1">
                {config.appIsFreeToSignUp
                  ? "It's free to get started. You won't pay until you want to publish your app."
                  : ''}
              </Typography>
            </Box>

            {showAuthPrompt && (
              <AuthEmbed
                ref={authPromptRef}
                show="signup"
                onSuccess={() => {
                  setShowAuthPrompt(false);
                }}
                onClose={() => {}}
              />
            )}
          </Container>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          style={{
            backgroundColor: 'background.default',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundImage:
              'url(https://d272s49zbiop50.cloudfront.net/landing-page/stock-photos/female/signup-workout-stock-photo.jpg)',
          }}
        ></Grid>
      </Grid>
    </Page>
  );
};

export default SignupPage;
